import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import SkiGearShippingPage from '@/v2/components/pages/public-pages/ski-gear-shipping-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/ski-gear-shipping-page'

interface SkiGearShippingPageProps {}

const Page: React.FC<SkiGearShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.ski_gear_shipping.title ?? ''}
        keywords={META_CONTENTS.ski_gear_shipping?.keywords ?? ''}
        description={META_CONTENTS.ski_gear_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <SkiGearShippingPage />
    </>
  )
}

export default Page
